<template>
  <div>登录成功！</div>
</template>

<script>
export default {
  name: 'index',
  components: {
  }
}
</script>
<style scoped>
</style>
